import { enUS as en, fr, es, de } from "date-fns/locale"

import { useGetLocaleFromList } from "./useGetLocalFromList"

const locales = { en, fr, es, de }

export function useDateLocale() {
    return useGetLocaleFromList(locales, en)
}